export default __webpack_public_path__ + "static/media/facebook.be4be0d4.svg";